<template>
    <div :class="config.rootClass">
        <div style="height: 0.41rem"></div>
        <Headbar
            @add="$emit('add')"
            :backgroundColor="config.background"
            :text="config.text"
            :isAdd="(state == 1 || state == 2) && status != 10 ? true : false"
            :disabled="state != 1"
        ></Headbar>
        <div class="warp" v-if="state == 1 || state == 2 || state == null">
            <template v-if="!(status == 10 || status == 20 || status == 15) && state == 1">
                <div class="status-20-tips">预选票无需自费，会务组统一结算</div>
                <list-item
                    v-for="(item, index) in tickets"
                    :key="index"
                    :index="index"
                    :isLast="index == tickets.length - 1"
                    :item="item.order"
                    :type="item.trafficType"
                    :status="item.status"
                    :dictsCodeMap="dictsCodeMap"
                    @handleStatus="handleStatus"
                ></list-item>
            </template>
            <noData
                v-if="status == 10"
                :icon="require('@assets/self.png')"
                :title="'无需订票'"
                :text="config.noDataText"
            ></noData>
            <div class="warp-booking" v-if="!tickets.length || (tickets.length && state == 2)">
                <div class="status-20-tips">预选票无需自费，会务组统一结算</div>
                <div class="radio-chunk">
                    <van-radio-group v-model="ticketRadio" direction="horizontal">
                        <van-radio name="1">会务组订票</van-radio>
                        <van-radio name="2">自驾</van-radio>
                    </van-radio-group>
                </div>
                <div class="footer" v-if="state == 1">
                    <span @click="onlineTickes">行程信息查询</span>
                </div>
                <div class="footer" v-if="state == 2">
                    <span class="radio-tips">您可切换【会务组订票】选项，进行来程选票操作</span>
                </div>
            </div>
        </div>
        <div class="warp" v-else-if="state == 0">
            <div class="state-0-chunk">
                <span class="tips">您为无需订票专家若有疑问，请联系专属小秘书</span>
                <div class="call" @click="handleCall" v-if="supervisorName">
                    <span>专属小秘书：{{ supervisorName }}</span>
                    <img src="@assets/call.svg" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Headbar from './Headbar.vue'
import ListItem from '@components/Common/ListItem.vue'
import noData from '@components/Common/NoData.vue'
import itineraryMixin from './itineraryMixin'

// 来程、返程订票的差异配置：direction 1 来程 2 返程
const DIRECTION_CONFIG = {
  1: {
    rootClass: 'incoming-booking',
    text: '来程订票',
    background: 'linear-gradient(180deg, #26C273 0%, #125C37 100%)',
    noDataText: '您为无需订票专家若有疑问，请联系专属小秘书',
    ticketStateKey: 'outboundTicketState',
    cabStateKey: 'outboundCabState',
    toastPrefix: '来程交通'
  },
  2: {
    rootClass: 'return-booking',
    text: '返程订票',
    background: 'linear-gradient(270deg, #B3CEFF 0%, #2C73FF 100%)',
    noDataText: '您已设置为无需订票，如需在线订票或添加个人已定票，请联系您的专属秘书进行更改',
    ticketStateKey: 'returnTicketState',
    cabStateKey: 'returnCabState',
    toastPrefix: '返程交通'
  }
}

export default {
  mixins: [itineraryMixin],
  components: {
    Headbar,
    ListItem,
    noData
  },
  props: {
    // 1 来程订票 2 返程订票
    direction: {
      type: [String, Number],
      default: 1
    },
    tickets: {
      type: Array,
      default: () => []
    },
    // 交通方式：1 会务组订票 2 自驾，null 为未选择
    state: {
      type: [String, Number],
      default: 0
    },
    status: {
      type: [String, Number],
      default: 0
    },
    // 对应方向的接站、送站需求，选择自驾时联动为无需
    cabState: {
      type: [String, Number],
      default: null
    },
    dictsCodeMap: {},
    supervisorName: {},

  },
  computed: {
    config () {
      return DIRECTION_CONFIG[Number(this.direction)] || DIRECTION_CONFIG[1]
    },
    ticketRadio: {
      get () {
        if (this.state === null || this.state === undefined || this.state === '') return null
        return String(this.state)
      },
      set (val) {
        if (String(val) === String(this.state)) return
        this.saveTicketState(Number(val))
      }
    }
  },
  methods: {
    handleCall () {
      this.$emit('call')
    },
    addSlefTickes () {
      this.$emit('addSlefTickes')
    },
    onlineTickes () {
      this.$emit('onlineTickes')
    },
    handleStatus (data) {
      this.$emit('handletTicket', {
        ...data,
        id: this.tickets[data.index].guestTicketId,
        iscoming: Number(this.direction)
      })
    },
    // 选择交通方式后直接保存
    saveTicketState (value) {
      const { ticketStateKey, cabStateKey, toastPrefix } = this.config
      const payload = {
        [ticketStateKey]: value
      }
      // 自驾：联动接站、送站为无需；后台设置为不安排（2）时该字段不提交
      if (value === 2 && Number(this.cabState) === 1) {
        payload[cabStateKey] = 0
      }
      const text = value === 2 ? '自驾' : '会务组订票'
      this.saveItinerary(payload, `${toastPrefix}您已选择【${text}】方式`)
    }
  }
}
</script>

<style lang="scss" scoped>
/* 来程、返程订票共用样式 */
.incoming-booking,
.return-booking {
    .warp {
        margin-top: -1rem;
        border-radius: 0.41rem;
        ::v-deep {
            .record-item {
                padding: 0.41rem 0.29rem 0 0.29rem;
                .line {
                    width: 10.26rem;
                    height: 0.02rem;
                    margin: 0 auto;
                    background: #ececec;
                }
            }
            .no-data {
                background: #fff;
                padding: 0.21rem 0;
                margin-top: 0.1rem;
                overflow: hidden;
                > img {
                    width: 100%;
                }
            }
        }
        .warp-booking {
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            align-items: center;

            padding-bottom: 1.23rem;
            background: #fff;
            border-radius: 0.41rem;
            cursor: pointer;
            > span {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .add {
                width: 5.21rem;
                height: 1.81rem;
                border-radius: 0.21rem;
                border: 0.02rem solid #dcdee0;
                font-size: 0.57rem;
                color: #162b40;
            }
            .booking {
                width: 5.21rem;
                height: 1.81rem;
                background: #0072f5;
                box-shadow: 0rem 0.25rem 0.49rem 0rem rgba(0, 114, 245, 0.15);
                border-radius: 0.21rem;
                font-size: 0.57rem;
                color: #ffffff;
            }
            .footer {
                margin-top: 0.61rem;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 0.33rem;
                > span {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.57rem;
                    color: #0072f5;
                }
                span:nth-child(1) {
                    width: 5.21rem;
                    height: 1.51rem;
                    border-radius: 0.21rem;
                    border: 0.02rem solid #0072f5;
                }
                span:nth-child(2) {
                    width: 5.35rem;
                    height: 1.51rem;
                    background: #0072f5;
                    box-shadow: 0rem 0.21rem 0.39rem 0rem rgba(0, 114, 245, 0.15);
                    border-radius: 0.26rem;
                    color: #fff;
                }
                .radio-tips {
                    padding: 0 1rem;
                    color: #fa6400;
                    font-size: 0.57rem;
                    border: none !important;
                    display: flex;
                    width: 100% !important;
                }
            }
        }
        .status-20-tips {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 1.5rem;
            background: #fef0e6;
            border-radius: 0.41rem;
            color: #fa6400;
            font-size: 0.57rem;
        }
        .radio-chunk {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 1.61rem 1.83rem 1rem 1.83rem;
        }
        .state-0-chunk {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            background: #fff;
            padding: 1.23rem 1rem;
            .tips {
                padding: 0 1rem;
                color: #f82f45;
                font-size: 0.57rem;
            }
            .call {
                margin-top: 1.23rem;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                padding: 0.4rem 1rem;
                background: #f2f7ff;
                border-radius: 0.33rem;
                span {
                    font-size: 0.57rem;
                    color: #0072f5;
                }
                img {
                    width: 0.6rem;
                    height: 0.6rem;
                }
            }
        }
        .radio-chunk {
            ::v-deep .van-radio-group--horizontal {
                width: 100% !important;
                justify-content: space-between !important;
            }
        }
    }
}

/* 来程订票沿用原视觉：模块底色为白、无数据图带圆角 */
.incoming-booking {
    .warp {
        background: #fff;
        ::v-deep {
            .no-data > img {
                border-radius: 0.41rem;
            }
        }
    }
}
</style>
